module.exports = __webpack_public_path__ + "img/symbol_7.db669b42.png";